import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

export default makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
    '& .MuiTabs-root': {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(5),
    },
    '& .MuiTab-root': {
      maxWidth: '100%', //removing retrictions on max-width, wondering why we have put restriction in molecule
    },
    '& .MuiButton-startIcon': {
      padding: pxToRem(6),
      ...theme.mixins.marginLeft(0),
    },
    '& .dayHighdescription': {
      color: theme.palette.text.darkGrey,
      paddingTop: 0,
      paddingBottom: theme.spacing(1),
    },
    '& .MuiGrid-grid-lg-5': {
      paddingTop: pxToRem(11),
    },
    '& svg': {
      width: '100%',
      height: '100%',
      ...theme.mixins.paddingRight(0),
    },
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      '&.MuiGrid-grid-lg-7': {
        paddingTop: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
      '& > div > div': {
        transform: 'none',
      },
    },
  },
  iconWithText: {
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),

    '& .MuiAvatar-root': {
      ...theme.mixins.marginRight(pxToRem(14)),
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginRight(pxToRem(20)),
      },
    },
  },
  highlightType: {
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(1),
    },
  },
  tabContent: {
    alignSelf: 'center',
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.paddingRight(theme.spacing(3)),
    },
  },
  frontImage: {
    width: '100%',
    height: '100%',
    '& picture': {
      paddingTop: 0,
    },
    [theme.breakpoints.down('md')]: {
      '& > div': {
        width: '100%',
      },
    },
    [theme.breakpoints.up('lg')]: {
      width: '125%',
      marginLeft: '-10%',
    },
    zIndex: 2,
    '& img': {
      position: 'relative',
      [theme.breakpoints.up('lg')]: {
        transform: `translateX(${theme.mixins.translateX(35)}%)`,
      },
    },
  },
  rearImage: {
    height: '100%',
    width: '100%',
    '& picture': {
      paddingTop: 0,
    },
    '& img': {
      position: 'relative',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  imageWrapper: {
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.paddingLeft('2%'),
    },
  },
  imageSection: {
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  Accordion: {
    '& .MuiExpansionPanelSummary-content': {
      margin: `${theme.spacing(3)} 0`,
    },
    '& .MuiExpansionPanelSummary-root': {
      padding: 0,
      minHeight: 'auto',
      '& .MuiExpansionPanelSummary-expandIcon > span': {
        color: theme.mixins.Black(),
      },
    },
    '& .MuiExpansionPanelDetails-root': {
      display: 'block',
      padding: 0,
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    },
    '& .MuiIconButton-root': {
      padding: 0,
      ...theme.mixins.paddingRight(pxToRem(10)),
    },
    '& .MuiIconButton-label': {
      color: theme.mixins.AbuDhabiOrange(),
    },
    '& .MuiSvgIcon-root': {
      maxWidth: theme.spacing(5),
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiGrid-item': {
        width: '100%',
      },
    },
  },
  title: {
    margin: `0 0 ${pxToRem(10)}`,
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(1),
    },
  },
  mainTitle: {
    marginBottom: theme.spacing(1),
  },
  regionField: {
    marginBottom: pxToRem(6),
    color: theme.palette.text.tertiary,
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  timing: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  description: {
    color: theme.palette.text.darkGrey,
    marginBottom: theme.spacing(2),
    ...theme.palette.common.ellipsis(5),
    textOverflow: 'ellipsis',
    maxHeight: 'calc(1rem * 2.1 * 5)',
  },
  divider: {
    marginTop: theme.spacing(2),
    '& div': {
      backgroundColor: theme.palette.common.LightSilver,
    },
  },
  avatarClassName: {
    color: theme.mixins.Grey(),
    backgroundColor: theme.mixins.White(),
    border: `1px solid ${theme.mixins.Grey()}`,
  },
}));
